import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';
import queryBuilder from '@glittr/frontend-core/src/plugins/validation/queryBuilder';
import DataItemResourceModel from '../../generated/types/model/resource/DataItemResourceModel';

export default class DataItemResourceViewModel extends DataItemResourceModel {
  schema = {
    ...queryBuilder.properties({
      title: {
        required: true,
        maxLength: 100,
      },
      categoryId: {
        required: true,
      },
    }),
  } as IJSONSchema;
}
